import { render, staticRenderFns } from "./my-pagination.vue?vue&type=template&id=a57a103c&scoped=true&"
import script from "./my-pagination.vue?vue&type=script&lang=js&"
export * from "./my-pagination.vue?vue&type=script&lang=js&"
import style0 from "./my-pagination.vue?vue&type=style&index=0&id=a57a103c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a57a103c",
  null
  
)

export default component.exports